/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubActiveReferralResponse { 
    crdReferralId?: string;
    population?: PcmsHubActiveReferralResponse.PopulationEnum;
}
export namespace PcmsHubActiveReferralResponse {
    export const PopulationEnum = {
        Adult: 'ADULT',
        Juvenile: 'JUVENILE'
    } as const;
    export type PopulationEnum = typeof PopulationEnum[keyof typeof PopulationEnum];
}


